import React, { Component } from 'react';
import SlideInModal from '../SlideInModal';
import DatePickerField from '../DatePickerField';
import CustomButton from '../CustomButton';
import localization from '@progressivebeef/shared/src/localization/i18n';
import { getLocale } from '@progressivebeef/shared/src/services/storageService/GlobalData';
import { RECORD_BINDER_STATUS } from '@progressivebeef/shared/src/constants/AppConstants';
import RecordBinderHelper from '@progressivebeef/shared/src/helpers/RecordBinderHelper';
import { showErrorAlert } from '../Alerts';
import './style.scss';

class RecordFiltersModal extends Component {
  static defaultProps = {
    onRequestClose: () => {},
    onApply: () => {},
    onClear: () => {},
    show: false,
  };

  constructor(props) {
    super(props);
    this.state = {
      status: props.selectedStatus !== null && props.selectedStatus !== undefined 
        ? props.selectedStatus 
        : RECORD_BINDER_STATUS.ACTIVE,
      startDate: props.selectedStartDate || null,
      endDate: props.selectedEndDate || null,
    };
  }

  componentDidUpdate(prevProps) {
    if (prevProps.show !== this.props.show && this.props.show) {
      this.setState({
        status: this.props.selectedStatus !== null && this.props.selectedStatus !== undefined
          ? this.props.selectedStatus
          : RECORD_BINDER_STATUS.ACTIVE,
        startDate: this.props.selectedStartDate || null,
        endDate: this.props.selectedEndDate || null,
      });
    }
  }

  handleStatusChange = (status) => {
    this.setState({ status });
  };

  handleStartDateChange = (date) => {
    this.setState({ startDate: date });
  };

  handleEndDateChange = (date) => {
    this.setState({ endDate: date });
  };

  handleApply = () => {
    const { status, startDate, endDate } = this.state;
    const locale = getLocale();
    if (RecordBinderHelper.isEndDateBeforeStartDate(startDate, endDate)) {
      const errorMsg = localization[locale].START_LESS_THAN_END_DATE;
      showErrorAlert(errorMsg, [
        { text: localization[locale].OK, onPress: () => {} },
      ]);
      return;
    }
    this.props.onApply({ status, startDate, endDate });
  };

  handleClear = () => {
    this.props.onClear();
  };

  render() {
    const { show, onRequestClose } = this.props;
    const { status, startDate, endDate } = this.state;
    const locale = getLocale();

    const statusOptions = [
      { 
        value: RECORD_BINDER_STATUS.ACTIVE, 
        label: localization[locale].ACTIVE || 'Active',
      },
      { 
        value: RECORD_BINDER_STATUS.ARCHIVED, 
        label: localization[locale].ARCHIVED || 'Archived',
      },
      { 
        value: RECORD_BINDER_STATUS.EXPIRED, 
        label: localization[locale].EXPIRED || 'Expired',
      },
    ];

    return (
      <SlideInModal
        show={show}
        onRequestClose={onRequestClose}
        title={localization[locale].FILTERS || 'Filters'}
      >
        <div className="record-filters-content">
          <div className="record-filters-body">
            <div className="record-filters-body-wrapper">
              {!this.props.hideStatus && (
                <div className="record-filter-section">
                  <label className="record-filter-label">
                    {localization[locale].STATUS || 'Status'}
                  </label>
                  <div className="record-filter-options">
                    {statusOptions.map((option) => (
                      <button
                        key={option.value}
                        className={`record-filter-option${status === option.value ? ' active' : ''}`}
                        onClick={() => this.handleStatusChange(option.value)}
                      >
                        {option.label}
                      </button>
                    ))}
                  </div>
                </div>
              )}

              <div className="record-filter-section">
                <label className="record-filter-label">
                  {localization[locale].SELECT_DATE_RANGE_LABEL}
                </label>
                <div className="record-date-range-filters">
                  <DatePickerField
                    placeholder={localization[locale].START_DATE}
                    value={startDate}
                    onChange={this.handleStartDateChange}
                    placement="bottom-start"
                  />
                  <DatePickerField
                    placeholder={localization[locale].END_DATE}
                    value={endDate}
                    onChange={this.handleEndDateChange}
                    minimumDate={startDate} 
                    placement="bottom-start"
                  />
                </div>
              </div>
            </div>
          </div>

          <div className="record-filter-footer">
            <div className="record-filter-buttons">
              <CustomButton
                title={localization[locale].RESET}
                onPressEvent={this.handleClear}
                buttonColor="transparent"
                textColor="#635F5F"
                customBtnStyles={{ width: '80px', padding: '8px' }}
                customTextStyles={{ fontSize: 14, fontWeight: 500 }}
              />
              <CustomButton
                title={localization[locale].APPLY}
                onPressEvent={this.handleApply}
                buttonColor="#502D7F"
                textColor="#fff"
                customBtnStyles={{ width: '80px', padding: '8px' }}
                customTextStyles={{ fontSize: 14, fontWeight: 500 }}
              />
            </div>
          </div>
        </div>
      </SlideInModal>
    );
  }
}

export default RecordFiltersModal;

